import React, { Component } from 'react';
import { Form, Button, Modal, Confirm, Icon } from 'semantic-ui-react';
import _ from 'lodash';
import { connect } from 'react-redux';
import 'react-intl-tel-input/dist/main.css';
import { logout } from '../actions/access.actions';
import { post, get, toWapi } from '../util/api';
import { withTranslation } from 'react-i18next';
import EcommerceTypes from '../pages/ecommerce_types.json';
import IntlTelInput from 'react-intl-tel-input';
class PlatformModal extends Component {
	state = {
		selectedPlatform: 'dialogtab',
		btnLoading: false,
		domain: 'https://',
	};
	
	async createTrialWeb() {
		await post('/live/payment/createFreeTrial', { pid: this.props.product.id, plan: 'start' }).then((data) => {
			get('/live/product').then((response) => {
				this.props.dispatch({
					type: 'PRODUCT_SUCCEEDED',
					product: response.product,
				});
			});
		});
	}
	async postData(values) {
		let { selectedPlatform, phone, domain, ecommerce, ecommerce_type } = this.state;
		this.setState({ btnLoading: true });
		if (values.extra) {
			values.phone = phone;
			values.extra = _.merge(values.extra, { domain, ecommerce: ecommerce ? 'yes' : 'no' });
		} else {
			values.extra = {};
			values.phone = phone;
			values.extra = { phone, domain, ecommerce: ecommerce ? 'yes' : 'no' };
		}
		if (ecommerce) values.extra.ecommerce_type = ecommerce_type;
		await post('/auth/updateInfo', values);
		await post('/live/product/setPanel', { panel: selectedPlatform }).then(() =>
			selectedPlatform === 'ext' ? this.createTrialExt() : this.createTrialWeb()
		);
	}
	openLogout() {
		this.setState({ logoutopen: true });
	}
	closeLogout() {
		this.setState({ logoutopen: false });
	}
	render() {
		let { t, user } = this.props;
		
		let { selectedPlatform, domain, ecommerce, activePage, ecommerce_type, lastModal } = this.state;
		console.log('ss', user, this.state);
		return (
			<div>
				<Confirm
					open={this.state.logoutopen}
					content={t('doYouLogout')}
					cancelButton={t('no')}
					confirmButton={t('yes')}
					onCancel={() => this.closeLogout()}
					onConfirm={() => this.props.dispatch(logout())}
				></Confirm>
				<Modal open closeIcon onClose={() => this.openLogout()} size="large">
				<Modal.Header>DialogTab Panel</Modal.Header>
				<Modal.Content>
							<Form onSubmit={() => this.postData(user)}>
							
								{/* <Form.Input
									label={t('phone')}
									value={phone}
									type="number"
									placeholder={t('companyPagePlaceholder', { query: t('phone') })}
									onChange={(e, { value }) => this.setState({ phone: value })}
								></Form.Input> */}
								<Form.Field>
									<label>{t('phone')}</label>
									<IntlTelInput
										containerClassName="intl-tel-input"
										name="phone"
										value={this.state.phone}
										inputClassName="form-control"
										preferredCountries={['tr']}
										onPhoneNumberChange={(status, value, countryData, number, id) => {
											this.setState({ phone: value, status, number, countryData });
										}}
									/>
								</Form.Field>

								<Form.Input
									name="domain"
									label={t('domain')}
									value={domain}
									placeholder={t('companyPagePlaceholder', { query: t('domain') })}
									onChange={(e, { value }) => this.setState({ domain: value })}
									required
								></Form.Input>

								<Form.Field>
									<label>{t('ecommerce')}</label>
									<Form.Checkbox
										label={t('areEcommerce')}
										checked={ecommerce}
										onChange={(e, { value }) => this.setState({ ecommerce: !ecommerce })}
									></Form.Checkbox>
								</Form.Field>
								{ecommerce ? (
									<Form.Field>
										<label>{t('type')}</label>
										<Form.Dropdown
											value={ecommerce_type}
											name="ecommerce_type"
											placeholder={t('selectEcommerce')}
											options={EcommerceTypes}
											selection
											onChange={(e, { value }) => this.setState({ ecommerce_type: value })}
										></Form.Dropdown>
									</Form.Field>
								) : null}
								<p>{t('platformTrialMessage', { day: 14 })}</p>
								<Form.Button basic positive loading={this.state.btnLoading}
								    disabled={!this.state.phone || !this.state.domain || this.state.domain === 'https://'}>
									{t('startTrial3', { day: 14 })}
								</Form.Button>
								{lastModal && <p>{t('startYourTrial')}</p>}
							</Form>
						
					</Modal.Content>
				</Modal>
			</div>
		);
	}
}
const stateToProps = (state) => ({ user: state.access.user.loggedUserObj, product: state.product.live });

export default connect(stateToProps)(withTranslation()(PlatformModal));
